import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchWebinars } from "store/webinarSlice";
import { useHistory } from "react-router-dom";

export default function WebinarTable({ color }) {
  const dispatch = useDispatch();
   const history = useHistory();
  const { items: webinars, loading, error } = useSelector((state) => state.webinars);

  useEffect(() => {
    dispatch(fetchWebinars());
  }, [dispatch]);

  // const handleEdit = (id) => {
  //   console.log("Edit webinar:", id);
  //   // open modal or navigate to edit page
  // };

  // const handleEditClick = (webinar) => {
  //   setSelectedWebinar(webinar);
  //   setShowEditForm(true);
  // };

   const handleEditClick = (webinar) => { 
    history.push(`/admin/webinar/${webinar.id}`);
  };

  // const handleDelete = (id) => {
  //   console.log("Delete webinar:", id);
  //   // dispatch(deleteWebinar(id)) after creating the delete thunk
  // };

  return (
    <>
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        {/* Header */}
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center justify-between">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3
                className={
                  "font-semibold text-lg " +
                  (color === "light" ? "text-blueGray-700" : "text-white")
                }
              >
                Webinar List
              </h3>
            </div>
            <div className="px-4">
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 text-sm font-semibold"
                onClick={() => console.log("Create webinar")}
              >
                + Create Webinar
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="block w-full overflow-x-auto">
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                {[
                  "Title",
                  "Description",
                  "Start Time",
                  "Duration (min)",
                  "Capacity",
                  "Registered",
                  "Price",
                  "Actions",
                ].map((heading, idx) => (
                  <th
                    key={idx}
                    className={`px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left ${
                      color === "light"
                        ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                        : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700"
                    }`}
                  >
                    {heading}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center p-4">
                    Loading...
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="8" className="text-center p-4 text-red-500">
                    {error}
                  </td>
                </tr>
              ) : !webinars ? (
                <tr>
                  <td colSpan="8" className="text-center p-4">
                    No webinars found.
                  </td>
                </tr>
              ) : (
                // webinars.map((webinar) => (
                  <tr key={webinars.id}>
                    <td className="border-t-0 px-6 py-4 text-sm">{webinars.title}</td>
                    <td className="border-t-0 px-6 py-4 text-sm">
                      {webinars.description}
                    </td>
                    <td className="border-t-0 px-6 py-4 text-sm">
                      {new Date(webinars.start_time).toLocaleString()}
                    </td>
                    <td className="border-t-0 px-6 py-4 text-sm">
                      {webinars.duration_minutes}
                    </td>
                    <td className="border-t-0 px-6 py-4 text-sm">{webinars.capacity}</td>
                    <td className="border-t-0 px-6 py-4 text-sm">
                      {webinars.registered_count}
                    </td>
                    <td className="border-t-0 px-6 py-4 text-sm">₹{webinars.price}</td>
                    <td className="border-t-0 px-6 py-4 text-sm">
                      <button
                        onClick={() => handleEditClick(webinars)}
                        className="bg-yellow-500 text-white px-3 py-1 rounded mr-2 text-xs hover:bg-yellow-600"
                      >
                        Edit
                      </button>
                      {/* <button
                        onClick={() => handleDelete(webinar.id)}
                        className="bg-red-500 text-white px-3 py-1 rounded text-xs hover:bg-red-600"
                      >
                        Delete
                      </button> */}
                    </td>
                  </tr>
                // ))
              )}
            </tbody>
          </table>

          {/* {showEditForm && (
        <div className="fixed inset-0 flex justify-center items-center bg-black/50">
          <EditWebinarForm
            selectedWebinar={selectedWebinar}
            onClose={() => setShowEditForm(false)}
          />
        </div>
      )} */}
        </div>
      </div>
    </>
  );
}

WebinarTable.defaultProps = {
  color: "light",
};

WebinarTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
